import React, { useContext, useMemo } from 'react';
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import Org from "src/routes/orgs/orgs/Org";
import { useDocumentTitle } from "usehooks-ts";
import { msg } from "src/app/msg";
import SignupRequest from "src/routes/orgs/signup-requests/SignupRequest";
import OrgUsersIndex from "src/routes/orguser/OrgUsersIndex";
import Text from "nood-comp/src/comp/text/Text";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
import CampusesIndex from "src/routes/orgs/campuses/CampusesIndex";
import SystemsIndex from "src/routes/orgs/systems/SystemsIndex";
import { AuthContext } from "src/session/AuthProvider";
import { permissionUtil } from "src/session/permissionUtil";
import SidebarNav from "nood-comp/src/comp/ui/nav/SidebarNav";
import VoucherCampaignIndex from "src/routes/orgs/membership/vouchers/campaigns/VoucherCampaignIndex";
import VoucherCodesIndex from "src/routes/orgs/membership/vouchers/voucher-code/VoucherCodeIndex";
import TierBatching from "src/routes/orgs/membership/tier-batching/TierBatching";
export default function OrgIndex(props) {
  var _useContext;
  useDocumentTitle(msg.title('Organization'));
  var _useContext$user = (_useContext = useContext(AuthContext)) === null || _useContext === void 0 ? void 0 : _useContext.user,
    permissions = _useContext$user.permissions;
  var filter = "z";
  var menu = useMemo(function () {
    return [{
      id: 'systems',
      title: 'Systems',
      icon: 'layers',
      content:
      /*#__PURE__*/
      /*SystemsIndex, */
      React.createElement(SystemsIndex, {
        key: "org-systems-".concat(filter)
      }),
      show: permissionUtil.has({
        permissions: permissions,
        entities: ['system', 'systems']
      })
    }, {
      id: 'campuses',
      title: 'Campuses',
      icon: 'layers',
      content: /*#__PURE__*/React.createElement(CampusesIndex, {
        key: "org-campuses-".concat(filter)
      }),
      show: permissionUtil.has({
        permissions: permissions,
        entities: ['campus', 'campuses']
      })
    }, {
      id: 'orgs',
      title: 'Organizations',
      icon: 'layers',
      content: /*#__PURE__*/React.createElement(Org, {
        key: "org-org"
      }),
      show: permissionUtil.has({
        permissions: permissions,
        entities: ['org', 'orgs']
      })
    }, {
      id: 'org-users',
      title: 'Org Users',
      icon: 'users',
      content: /*#__PURE__*/React.createElement(OrgUsersIndex, {
        key: "org-org-users"
      }),
      show: permissionUtil.has({
        permissions: permissions,
        entities: ['orguser', 'orgusers']
      })
    }, {
      id: 'invite-requests',
      title: 'Signup Requests',
      icon: 'user-plus',
      content: /*#__PURE__*/React.createElement(SignupRequest, {
        key: "org-signup-requests"
      }),
      show: permissionUtil.has({
        permissions: permissions,
        entities: ['request_invites', 'request_invite']
      })
    }, {
      id: "membership",
      title: "Membership",
      icon: "users",
      content: /*#__PURE__*/React.createElement(React.Fragment, null, "Membership"),
      show: true,
      childMenus: [{
        id: "filler",
        title: "Filler",
        icon: "file",
        content: /*#__PURE__*/React.createElement(React.Fragment, null, "Nothing here")
      }, {
        id: "vouchers",
        title: "Vouchers",
        icon: "gift",
        content: /*#__PURE__*/React.createElement(React.Fragment, null),
        childMenus: [{
          id: "campaigns",
          title: "Campaigns",
          icon: "gift",
          content: /*#__PURE__*/React.createElement(VoucherCampaignIndex, null)
        }, {
          id: "voucher-codes",
          title: "Voucher Codes",
          icon: "tag",
          content: /*#__PURE__*/React.createElement(VoucherCodesIndex, null)
        }]
      }, {
        id: "batch-reset-tier",
        title: "Batch Reset Tier",
        icon: "refresh-cw",
        content: /*#__PURE__*/React.createElement(TierBatching, null)
      }]
    }];
  }, []);
  return /*#__PURE__*/React.createElement(SidebarNav, {
    menu: menu,
    "default": "orgs",
    key: "org-index-sidebar-nav",
    queryStringFilter: "pg",
    navTitle: "Organizations",
    navCaption: "Manage organizations"
  });
}
var OrgHeader = function OrgHeader(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, "Organizations"), /*#__PURE__*/React.createElement(Text, {
    secondary: true
  }, "Manage organizations")), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 10
  }));
};